const GATE_LABELS: Record<string, string> = {
  email_verify: "Email",
  password: "Password",
  nda: "NDA",
};

type Props = {
  gates: string[];
  current: string;
};

export function GateStepper({ gates, current }: Props) {
  if (!gates.length) return null;
  const currentIdx = gates.indexOf(current);
  return (
    <ol className="gate-stepper" aria-label="Access steps">
      {gates.map((g, i) => {
        const done = currentIdx > i || current === "content";
        const active = g === current || (current === "email_pending" && g === "email_verify");
        return (
          <li key={g} className={`gate-stepper__item${done ? " is-done" : ""}${active ? " is-active" : ""}`}>
            <span className="gate-stepper__dot" aria-hidden="true" />
            <span>{GATE_LABELS[g] ?? g}</span>
          </li>
        );
      })}
    </ol>
  );
}
